<template>
  <div class="flex h-full">
    <h4 class="mr-8 flex items-center justify-center uppercase font-semibold">
      Reportes
    </h4>
    <router-link
      v-for="(menu, k) in options"
      v-bind:key="k"
      tag="span"
      :to="menu.path"
      class="
        cursor-pointer
        h-full
        p-2
        mx-2
        flex
        items-center
        justify-center
        -mb-2
      "
      exact-active-class="active"
      @click.native="$emit('clicked')"
    >
      <i :class="`el-icon-fa-${menu.icon} mr-2`"></i>
      {{ menu.name }}
    </router-link>
  </div>
</template>

<script>
import { checkPermissions } from "../../utils";

export default {
  name: "ReportSubMenu",
  data() {
    return {
      reportsMenu: [
        {
          icon: "users",
          path: "/reports/remployees",
          name: "REPORTES DE EMPLEADOS",
          submodule: "Empleados",
        },
        {
          icon: "folder",
          path: "/reports/rplanilla",
          name: "REPORTES DE PLANILLA",
          submodule: "Planillas",
        },
        {
          icon: "folder",
          path: "/reports/rgeneral",
          name: "REPORTES GENERALES",
          submodule: "Generales",
        },
      ],
    };
  },
  computed: {
    options() {
      return this.reportsMenu.filter(
        (item) =>
          this.$store.getters.isSuper ||
          checkPermissions(`Reportes:${item.submodule}`, "Page:view") ||
          checkPermissions(`Reportes:${item.submodule}`, "Page:viewOwn")
      );
    },
  },
};
</script>
